if (!customElements.get('product-tabs')) {
  class ProductTabs extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('.tabs-nav__btn'));
      this.panels = Array.from(this.querySelectorAll('.tabs-panel'));
      this.buttons.forEach((btn) => {
        btn.addEventListener('click', () => this.activate(btn.dataset.tab));
      });
    }
    activate(id) {
      this.buttons.forEach((b) => {
        const on = b.dataset.tab === id;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      this.panels.forEach((p) => {
        p.classList.toggle('is-active', p.dataset.panel === id);
      });
    }
  }
  customElements.define('product-tabs', ProductTabs);
}
